export const CASES = {
    UPDATE_DATE_MATH: 'UPDATE_DATE_MATH',
    UPDATE_MACRO_TRIGGERS: 'UPDATE_MACRO_TRIGGERS',
    UPDATE_DATE_MATH_SEARCH_FORM: 'UPDATE_DATE_MATH_SEARCH_FORM',
    CLEAR_DATE_MATH_MACROS: 'CLEAR_DATE_MATH_MACROS0',
    CLEAR_DATE_MATH: 'CLEAR_DATE_MATH',
};
